<app-upsell-card
  htmlTitle="<strong>Grow Your Hair</strong> While You Optimize Everything Else"
  question="Would you like to add a clinically-proven hair loss treatment to your plan?"
  [slug]="slug"
  [options]="options"
>
  <p class="mb-4">
    You're already investing in looking and feeling your best. Hair is part of that same picture, and the hormonal
    systems you're focused on are closely tied to hair growth.
  </p>
  <p class="mb-4">
    Finasteride and minoxidil are the two most proven, FDA-approved treatments to regrow and protect your hair:
  </p>
  <p class="mb-4"><strong>Minoxidil</strong> increases blood flow to the follicle to regrow and thicken hair.</p>
  <p class="mb-4">
    <strong>Finasteride</strong> is a once-daily tablet that blocks DHT, the hormone behind most hair loss. Strongest
    results when started early.
  </p>
</app-upsell-card>
